import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContractSettlementCompanyPage } from "@/features/contracts/contract-settlement-company-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Spolka deep-linkowalna; zly param z zakladki nie moze wywalic trasy (catch).
// union+transform: parser TanStacka konwertuje wartosci numeryczne na number.
const searchSchema = z.object({
	spolka: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
});

export type ContractSettlementCompanySearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/$id/po-spolce")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractSettlementCompanyPage,
	validateSearch: (search: Record<string, unknown>): ContractSettlementCompanySearch =>
		searchSchema.parse(search),
});
